import { InventoryMetersDB } from '../../indexed_db/inventoryMetersDB';

let inventoryMetersDB: InventoryMetersDB;

const inventoryMetersDbFactory = () => (inventoryMetersDB = new InventoryMetersDB());

/**
 * @deprecated Use `useServices` hook instead.
 */
export const getInventoryMetersDbApi = (): InventoryMetersDB => inventoryMetersDB ?? inventoryMetersDbFactory();
